export enum BusinessTabName {
  Packages = 'packages',
  Balance = 'balance',
  Invoices = 'invoices',
}

export interface BusinessTabsProps {
  activeTab: BusinessTabName;
}
